import request from "../utils/request.js";
let api = {}; //设置一个对象暴露出去

// api.api1 = () => request("get", "/api1"); // 仅地址
// api.api2 = (参数) => request("post", "url", 参数); // 地址和传参
// api.api3 = (params) => request("post", `url/${params}`); //携带在url中的参数
// api.api4 = (params) => request("post", `url/${params.id}`, params); //携带在url中的参数和请求体参数
// api.api5 = (id, params) => request("post", `url/${id}`, params); //根据项目情况，自己试一下就理解了

api.getwechatconfig=(parameter)=>request("get","/api/wecharshare/wechatconfig",parameter);

api.getprojectinfo = (parameter) => request("get", "/api/mobile/getprojectinfo",parameter);
api.getvisitorinfo=(parameter)=>request('get',"/api/mobile/visitor",parameter)
api.getprojectconfiginfo = (parameter) => request("get", "/api/mobile/getprojectconfiginfo",parameter);
api.getfieldslist = (parameter) => request("get", "/api/mobile/getfieldslist",parameter);
api.getquestionlist = (parameter) => request("get", "/api/mobile/getquestionlist",parameter);
api.login = (parameter) => request("post", "/api/mobile/login",parameter);
api.getYzm = (parameter) => request("post", "/api/mobile/sendsms",parameter);
api.getEmialYzm = (parameter) => request("post", "/api/mobile/sendmail",parameter);

api.getInfo = () => request("get", "/api/mobile/userinfo");
api.personalSave = (parameter) => request("post", "/api/mobile/setfields",parameter);
api.getCountryList = (parameter) => request("get", "/api/mobile/common/countrylist",parameter);
api.getProvinceList = (parameter) => request("get", "/api/mobile/common/provincelist",parameter);
api.getIssueatList = () => request("get", "/api/mobile/common/issueatlist");
api.setQuestion = (parameter) => request("post", "/api/mobile/setquestion",parameter);
api.getappointmentlist = (parameter) => request("get", "/api/mobile/getappointmentlist",parameter);

api.checkmaxnum = (parameter) => request("post", "/api/mobile/checkmaxnum",parameter);
api.submitappoint = (parameter) => request("post", "/api/mobile/submitappoint",parameter);
api.setauditstatus = (parameter) => request("post", "/api/mobile/setauditstatus",parameter);
api.getdropdownlist = (parameter) => request("get", "/api/mobile/common/getdropdownlist?code="+parameter);

api.getuserinfobydata = (parameter) => request("get", "/api/mobile/getuserinfobydata",parameter);
api.getcheckedappointmentlist = (parameter) => request("get", "/api/mobile/getcheckedappointmentlist",parameter);

api.cardimage = (parameter) => request("post", "/api/mobile/common/cardimage",parameter);
api.registersuccess = (parameter) => request("get", "/api/mobile/registersuccess",parameter);
api.getuserauditstatus = () => request("get", "/api/mobile/getuserauditstatus",);
api.CheckAuditStatus = () => request("get", "/api/mobile/CheckAuditStatus",);
api.getvalidatecode = (code) => request("get", "/api/mobile/common/getvalidatecode/"+code,);
api.getcertback = (parameter) => request("get", "/api/mobile/getcertback",parameter);
api.UserInfoBySerach = (parameter) => request("get", "/api/mobile/UserInfoBySerach",parameter);
api.getBannerList = (parameter) => request("get", "/api/banner/list",parameter);


//暴露对象
export default api





